export interface BatchMarcFileUploadResponse {
  fileName: string
}

export function BatchMarcFileUploadResponseFromJSON(
  json: any
): BatchMarcFileUploadResponse {
  return BatchMarcFileUploadResponseFromJSONTyped(json)
}

export function BatchMarcFileUploadResponseFromJSONTyped(
  json: any
): BatchMarcFileUploadResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fileName: json.file_name
  }
}
